module.exports = __webpack_public_path__ + "img/Email.89d482ee.svg";